// extracted by mini-css-extract-plugin
export default {"table":"OccupanciesTab_table__SitdJ","smallBtn":"OccupanciesTab_smallBtn__wSd7S"};